import React from "react";
import Dialog from "@material-ui/core/Dialog";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import styled from "styled-components";
import ShareLinkButtons from 'components/shared/buttons/ShareLinkButtons'
import CopyLinkField from 'components/shared/form_fields/CopyLinkField'
import { withTheme } from "styled-components";
import useMediaQuery from "@material-ui/core/useMediaQuery";
import TransparentButton from 'components/shared/buttons/TransparentButton'

const CloseButton = styled<any>(TransparentButton).attrs({
	className: "w-full mt-2 rounded border border-solid border-gray-200"
})``;

const ShareDialog = styled<any>(Dialog)`
	max-width: 500px;
	margin: 0 auto;
	@media (max-width: ${props => props.theme.breakpoints.sm}) {
		width: 100%;
        max-width:100%;
	}

	.MuiPaper-root {
        padding:10px;
        display:flex;
        flex-direction:column;
        align-items:center;
    }
`;

const Title = styled<any>(DialogTitle).attrs({ className: 'text-center pb-0' })`
	color: ${props => props.theme.colors.orange};
`;

const Content = styled<any>(DialogContent).attrs({ className:'p-3' })``;

const Explanation = styled.p.attrs({ className:'text-center py-3' })`
	font-family: ${props => props.theme.fonts.poppins};
`;

export default withTheme(({ theme, open, link, onClose, story }) => {

	const isFullScreen = useMediaQuery(`(max-width: ${theme.breakpoints.sm})`);

    return (
		<ShareDialog open={open} onClose={onClose} fullScreen={isFullScreen}>
			<Title>Gift full story for free</Title>
			<Content>
				<Explanation>
					As a benefit of your subscription, you can share articles with friends! Copy
					the link and send to friends.
					<br /> <br />
					Recipients can read this story after sharing their email. They will not have
					full access to other articles.
				</Explanation>
				<ShareLinkButtons story={story} link={link} />
				<CopyLinkField story={story} link={link} />
				{isFullScreen && <CloseButton onClick={() => onClose()}> Close </CloseButton>}
			</Content>
		</ShareDialog>
	);
})
